<div class="job-flow-diagram__viewport">
    <div class="job-flow-diagram__scene" [style.width.px]="width()" [style.height.px]="height()">
        <svg
            class="job-flow-diagram__edges"
            [attr.width]="width()"
            [attr.height]="height()"
            [attr.viewBox]="'0 0 ' + width() + ' ' + height()"
            aria-hidden="true"
        >
            <defs>
                <marker
                    id="job-flow-arrow"
                    markerWidth="10"
                    markerHeight="10"
                    refX="9"
                    refY="3"
                    orient="auto"
                    markerUnits="strokeWidth"
                >
                    <path d="M0,0 L0,6 L9,3 z"></path>
                </marker>
            </defs>

            @for (edge of edges(); track edge.id) {
                <path class="job-flow-diagram__edge-outline" [attr.d]="path(edge.points)" />
                <path class="job-flow-diagram__edge" [attr.d]="path(edge.points)" marker-end="url(#job-flow-arrow)" />
            }
        </svg>

        @for (node of nodes(); track node.opId) {
            <data-terminal-job-flow-node
                class="job-flow-diagram__node"
                [style.left.px]="node.x"
                [style.top.px]="node.y"
                [style.width.px]="node.width"
                [style.height.px]="node.height"
                [workStep]="node"
                [machineNames]="machineNames()"
                [selected]="node.opId === selectedWorkStepId()"
            />
        }

        @for (stackGroup of stackGroups(); track stackGroup.id) {
            <mat-card
                appearance="outlined"
                class="hdmui job-flow-diagram__stack-group hdmui-background-2 hdmui-m-0"
                [style.left.px]="stackGroup.x"
                [style.top.px]="stackGroup.y"
                [style.width.px]="stackGroup.width"
                [style.height.px]="stackGroup.height"
            >
                @if (stackGroup.label) {
                    <h3 class="job-flow-diagram__stack-group-label hdmui-m-0">{{ stackGroup.label }}</h3>
                }
                @for (stack of stackGroup.stacks; track $index) {
                    <data-terminal-job-flow-stack-card
                        [stack]="stack"
                        [isInputStackCompleted]="stackGroup.isInputStackCompleted"
                    />
                }
            </mat-card>
        }
    </div>
</div>
